<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" mat-dialog-close>
    Logout
  </button>
</mat-dialog-actions>